import React, { useEffect, useState } from 'react';
import compareIcon from '../../../../../assets/image/compare-icon.svg';
import customizeIcon from '../../../../../assets/image/customize-icon.svg';
import favIcon from '../../../../../assets/image/fav-icon.svg';
import favActiveIcon from '../../../../../assets/image/fav_icon_color.svg';
import ScheduleReportModal from '../../components/scheduleReportModal';
import {
	DATE_RANGE,
	formatDateDDMMYYYY,
	getDateRange,
	TRANSACTION_TYPE,
} from '../../../../../utils/constant';
import {
	addFavouriteReport,
	downloadPdfReport,
	exportExcelReport,
	getCustomerReport,
	removeFavouriteReport,
} from '../../../../../services/reports';
import { toast } from 'react-toastify';
import ReportHeaderComponent from '../../components/reportHeaderComponent';
import ReportSubHeaderComponent from '../../components/reportSubHeaderComponent';
import ReportTableComponent from '../../components/reportTableComponent';
import CompareCustomerReportModel from '../../components/compareCustomerReportModal';
import CustomizeTableColumnsModal from '../../components/customizeTableColumnsModal';
import { useNavigate } from 'react-router-dom';

export default function SaleByCustomers({ activeTab, setIsCollapse, isCollapse }) {
	const [isLoaderCustomerReport, setLoaderCustomerReport] = useState(false);
	const [isScheduleModelOpen, setIsScheduleModelOpen] = useState(false);
	const [compareModelOpen, setCompareModelOpen] = useState(false);
	const [customizeColumnsModel, setCustomizeColumnsModal] = useState(false);
	const [CustomDateRange, setCustomDateRange] = useState([null, null]);
	const [transactionsTypeSelectList, setTransactionsTypeSelectList] = useState(['invoices']);
	const [customerReportList, setCustomerReport] = useState([]);
	const [metaData, setMetaData] = useState([]);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const [scheduledId, setScheduledId] = useState(null);
	const [isFavReport, setIsFavReport] = useState(false);
	const [sortDirection, setSortDirection] = useState({});
	const [dropdownState, setDropdownState] = useState({
		date_range: false,
		transaction_type: false,
		isCustomDateOpen: false,
	});
	const [isLoading, setLoading] = useState({
		pdf: false,
		excel: false,
		isLoader: false,
	});

	const [params, setParams] = useState({
		date_range: 'this_month',
		transaction_type: 'invoices',
		compare_type: null,
		compare_count: null,
		start_date: null,
		end_date: null,
		sort_by: 'customer_name',
		order_by: 'desc',
		page: 1,
		page_size: 20,
		is_arrange_year_period: false,
	});
	const [startDate, endDate] = CustomDateRange;
	const customerAvailableTableColumnsList = [
		{ key: 'invoice_count', label: 'INVOICE COUNT' },
		{ key: 'sales', label: 'SALES' },
		{ key: 'sales_with_tax', label: 'SALES WITH TAX' },
		{ key: 'credit_note_count', label: 'CN COUNT' },
		{ key: 'credit_note_amount', label: 'CN AMOUNT' },
	];
	const [selectedColumnsList, setSelectedColumnsList] = useState([
		{ key: 'invoice_count', label: 'INVOICE COUNT' },
		{ key: 'sales', label: 'SALES' },
		{ key: 'sales_with_tax', label: 'SALES WITH TAX' },
	]);
	useEffect(() => {
		if (startDate && endDate) {
			setParams((prev) => ({
				...prev,
				start_date: formatDateDDMMYYYY(startDate),
				end_date: formatDateDDMMYYYY(endDate),
			}));
		}
	}, [startDate, endDate]);

	const getCustomerReportList = async (param = null) => {
		try {
			setLoaderCustomerReport(true);
			const res = await getCustomerReport(param || params);
			if (res.success) {
				const { report, isFavourate, schedulerID } = res.data;
				setIsFavReport(isFavourate);
				setScheduledId(schedulerID);
				if (report) {
					const { data, meta } = report;
					setMetaData(meta);
					if (data) {
						setCustomerReport(data);
					}
				}
			} else {
				toast.error(res.message);
			}
		} catch (error) {
		} finally {
			setLoaderCustomerReport(false);
		}
	};

	const handleFilter = (type) => {
		let list = [];
		setTransactionsTypeSelectList((prev) => {
			if (prev.includes(type)) {
				const data = prev.filter((item) => item !== type);
				list = data;
				// REMOVE
				return data;
			} else {
				const data = [...prev, type];
				list = data;
				// ADD
				return data;
			}
		});

		setParams((prev) => ({
			...prev,
			transaction_type:
				list.includes('invoices') && list.includes('credit_notes')
					? 'all'
					: list.includes('invoices')
						? 'invoices'
						: list.includes('credit_notes')
							? 'credit_notes'
							: '',
		}));
	};

	const checked = (key) => transactionsTypeSelectList.includes(key);

	const handleDownloadPdf = async () => {
		try {
			setLoading((prev) => ({
				...prev,
				pdf: true,
				isLoader: true,
			}));
			let data;
			data =
				params.date_range === 'custom'
					? {
							start_date: params.start_date,
							end_date: params.end_date,
						}
					: {
							date_range: params.date_range,
						};
			const res = await downloadPdfReport('customers', data);
			if (res.success) {
				const { signed_url } = res.data;
				window.open(signed_url, '_blank');
				toast.success('Sale By Customers report is printed successfully');
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setLoading((prev) => ({
				...prev,
				pdf: false,
				isLoader: false,
			}));
		}
	};
	const handleExportExcel = async () => {
		try {
			setLoading((prev) => ({
				...prev,
				excel: true,
				isLoader: true,
			}));
			let data;
			data =
				params.date_range === 'custom'
					? {
							start_date: params.start_date,
							end_date: params.end_date,
						}
					: {
							date_range: params.date_range,
						};
			const res = await exportExcelReport('customers', data);
			if (res.success) {
				const a = document.createElement('a');
				a.href = res.data.signed_url;
				a.download = `customer_report_table.xlsx`;
				document.body.appendChild(a);
				a.click();
				a.remove();
				toast.success(res.message);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setLoading((prev) => ({
				...prev,
				excel: false,
				isLoader: false,
			}));
		}
	};

	const handleFavReport = async () => {
		try {
			const body = {
				report_key: activeTab.toLowerCase().replaceAll(' ', '_'),
			};
			const res = await addFavouriteReport(body);
			if (res.success) {
				toast.success(res.message);
				setIsFavReport(!isFavReport);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {}
	};

	const handleRemoveFavReport = async () => {
		try {
			const res = await removeFavouriteReport(activeTab.toLowerCase().replaceAll(' ', '_'));
			if (res.success) {
				toast.success(res.message);
				setIsFavReport(!isFavReport);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {}
	};

	useEffect(() => {
		getCustomerReportList();
	}, [params.sort_by, params.order_by]);

	return (
		<div>
			<div>
				<div style={{ backgroundColor: '#FFF', position: 'sticky', top: 0, zIndex: 100 }}>
					<ReportHeaderComponent
						title={'Sales'}
						subtitle={true}
						favIconButton={{
							fav_icon: isFavReport ? favActiveIcon : favIcon,
							handler: () => {
								if (isFavReport) {
									handleRemoveFavReport();
								} else {
									handleFavReport();
								}
							},
						}}
						setIsCollapse={setIsCollapse}
						isCollapse={isCollapse}
						activeTab={activeTab}
						fromDate={
							params.date_range !== null && params.date_range !== 'custom'
								? getDateRange(params.date_range).from
								: startDate !== null
									? startDate
									: ''
						}
						toDate={
							params.date_range !== null && params.date_range !== 'custom'
								? getDateRange(params.date_range).to
								: endDate !== null
									? endDate
									: ''
						}
						buttons={[
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Schedule Report',
								isDropdown: false,
								disabled: false,
								handler: () => {
									setIsScheduleModelOpen(true);
								},
							},
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Print/Download',
								loader: isLoading.isLoader && isLoading.pdf,
								disabled: isLoading.isLoader && isLoading.pdf,
								handler: () => handleDownloadPdf(),
							},
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Send Email',
								disabled: false,
								handler: () =>
									navigate(
										`/user/${suburl}/reports/send-emails/${activeTab.toLowerCase().replaceAll(' ', '_')}`,
										{ state: { filter: params } },
									),
							},
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Export to Excel',
								loader: isLoading.isLoader && isLoading.excel,
								disabled: isLoading.isLoader && isLoading.excel,
								handler: () => handleExportExcel(),
							},
						]}
					/>
					<ReportSubHeaderComponent
						getReportList={getCustomerReportList}
						params={params}
						setParams={setParams}
						startDate={startDate}
						endDate={endDate}
						setCustomDateRange={setCustomDateRange}
						dropdownState={dropdownState}
						setDropdownState={setDropdownState}
						filters={[
							{
								type: 'dropdown',
								label: 'Date Range',
								key: 'date_range',
								options: DATE_RANGE,
								isCustom: true,
							},
							{
								type: 'checkbox',
								label: 'Transactions Type',
								key: 'transaction_type',
								handleFilter: handleFilter,
								checked: checked,
								options: TRANSACTION_TYPE,
							},
						]}
					/>
				</div>
				<ReportTableComponent
					activeTab={activeTab}
					reportList={customerReportList}
					isLoader={isLoaderCustomerReport}
					metaData={metaData}
					selectedColumnsList={selectedColumnsList}
					params={params}
					setParams={setParams}
					sortDirection={sortDirection}
					setSortDirection={setSortDirection}
					fromDate={
						params.date_range !== null && params.date_range !== 'custom'
							? getDateRange(params.date_range).from
							: startDate !== null
								? startDate
								: ''
					}
					toDate={
						params.date_range !== null && params.date_range !== 'custom'
							? getDateRange(params.date_range).to
							: endDate !== null
								? endDate
								: ''
					}
					actions={[
						{
							key: 'compare',
							label: 'Compare with',
							icon: compareIcon,
							onClick: () => setCompareModelOpen(true),
							showArrow: true,
						},
						{
							key: 'customize',
							label: 'Customize Table Columns',
							icon: customizeIcon,
							showArrow: false,
							onClick: () => setCustomizeColumnsModal(true),
						},
					]}
				/>
			</div>
			{isScheduleModelOpen && (
				<ScheduleReportModal
					isScheduleModelOpen={isScheduleModelOpen}
					setIsScheduleModelOpen={setIsScheduleModelOpen}
					activeTab={activeTab}
					id={scheduledId}
				/>
			)}
			{compareModelOpen && (
				<CompareCustomerReportModel
					compareModelOpen={compareModelOpen}
					params={params}
					setCompareModelOpen={setCompareModelOpen}
					setParams={setParams}
					getReportList={getCustomerReportList}
				/>
			)}
			{customizeColumnsModel && (
				<CustomizeTableColumnsModal
					isOpenModal={customizeColumnsModel}
					setIsOpenModal={setCustomizeColumnsModal}
					availableColumnsList={customerAvailableTableColumnsList}
					selectedColumsList={selectedColumnsList}
					setSelectedColumnsList={setSelectedColumnsList}
					setParams={setParams}
					params={params}
					getReportList={getCustomerReportList}
				/>
			)}
		</div>
	);
}
